"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3405],{

/***/ 60996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ map_card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/see-more/index.ts + 1 modules
var see_more = __webpack_require__(97932);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/molecules/card/index.ts + 1 modules
var card = __webpack_require__(25649);
;// CONCATENATED MODULE: ./components/organisms/map-card/MapCard.tsx





/**
 * MapCard
 */ var MapCard = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _buttonVariant = param.buttonVariant, buttonVariant = _buttonVariant === void 0 ? "primary" : _buttonVariant, buttonText = param.buttonText, caption = param.caption, characteristicsList = param.characteristicsList, subtitle = param.subtitle, title = param.title, orientation = param.orientation, mapIframe = param.mapIframe, numberOfElements = param.numberOfElements, link = param.link;
    var t = (0,useTranslation/* default */.Z)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        multimediaProps: {
            src: mapIframe,
            popUp: true,
            descPopUp: subtitle,
            popUpTitle: title
        },
        orientation: orientation,
        className: "bg-white  ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-1 text-primary-400",
                children: [
                    caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-caption text-caption--small",
                        children: caption
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-heading text-heading--h3",
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-body text-body--secondary font-bold",
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2 mt-8 text-primary-400\n        ".concat(orientation === "column" ? "flex flex-col" : "grid grid-cols-2 gap-4 "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(see_more/* default */.Z, {
                    labels: {
                        viewLess: t("components.atoms.seeMore.labels.viewLess"),
                        viewMore: t("components.atoms.seeMore.labels.viewMore")
                    },
                    icon: "ArrowDownPri",
                    expanded: false,
                    variant: "primary",
                    numberOfElements: numberOfElements,
                    children: characteristicsList.map(function(element, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    className: "text-primary-400",
                                    height: 16,
                                    width: 16,
                                    src: element.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-body text-body--secondary ",
                                    children: element.text
                                })
                            ]
                        }, index);
                    })
                })
            }),
            buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-t border-primary-400 pt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: link,
                    passHref: true,
                    prefetch: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                        as: "a",
                        className: "!w-full",
                        variant: buttonVariant,
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                            arrow: true,
                            as: "span",
                            variant: "alternative",
                            children: buttonText
                        })
                    })
                })
            })
        ]
    });
};
MapCard.displayName = "MapCard";

;// CONCATENATED MODULE: ./components/organisms/map-card/index.ts

/* harmony default export */ var map_card = (MapCard);


/***/ }),

/***/ 24324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ building_carrousel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/section-text/index.ts
var section_text = __webpack_require__(67526);
// EXTERNAL MODULE: ./components/atoms/tabs/index.ts + 1 modules
var tabs = __webpack_require__(37195);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/section-text/SectionText.tsx
var SectionText = __webpack_require__(60652);
// EXTERNAL MODULE: ./components/molecules/swiper-custom/index.ts + 1 modules
var swiper_custom = __webpack_require__(6306);
// EXTERNAL MODULE: ./components/molecules/card/index.ts + 1 modules
var card = __webpack_require__(25649);
// EXTERNAL MODULE: ./components/organisms/apartment-card/index.ts + 1 modules
var apartment_card = __webpack_require__(92993);
// EXTERNAL MODULE: ./components/organisms/map-card/index.ts + 1 modules
var map_card = __webpack_require__(60996);
;// CONCATENATED MODULE: ./components/templates/building-carrousel/BuildingCarrousel.tsx









/**
 * BuildingCarrousel
 */ var BuildingCarrousel = function(_param) {
    var buildings = _param.buildings, tabsName = _param.tabsName, title = _param.title, caption = _param.caption, desc = _param.desc, textColor = _param.textColor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "buildings",
        "tabsName",
        "title",
        "caption",
        "desc",
        "textColor"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(container/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                caption: caption,
                direction: "row",
                textAlign: "start",
                variant: textColor,
                title: title,
                desc: desc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs["default"], {
                tabsName: tabsName,
                children: buildings.map(function(building, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "mt-10 flex flex-col gap-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-2",
                                children: [
                                    building.tipology.caption && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "#".concat(building.tipology.caption).concat(index),
                                        passHref: true,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                            as: "a",
                                            variant: "outline",
                                            size: "small",
                                            children: building.tipology.caption
                                        })
                                    }),
                                    building.sharedSpaces.caption && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "#".concat(building.sharedSpaces.caption).concat(index),
                                        passHref: true,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                            as: "a",
                                            variant: "outline",
                                            size: "small",
                                            children: building.sharedSpaces.caption
                                        })
                                    }),
                                    building.map.caption && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "#".concat(building.map.caption).concat(index),
                                        passHref: true,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                            as: "a",
                                            variant: "outline",
                                            size: "small",
                                            children: building.map.caption
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "".concat(building.tipology.caption).concat(index),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                                        caption: building.tipology.caption,
                                        direction: "row",
                                        textAlign: "start",
                                        variant: textColor,
                                        title: building.tipology.title,
                                        desc: building.tipology.desc
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_custom["default"], {
                                        scrollbar: true,
                                        navigation: true,
                                        slidesPerView: 3,
                                        slidesPerViewMobile: 1,
                                        gap: 24,
                                        slideGrow: true,
                                        children: building.tipology.apartments.map(function(tipology, index) {
                                            var ref;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(apartment_card/* default */.Z, (0,_object_spread/* default */.Z)({
                                                landing: true,
                                                cardOrientation: building.tipology.apartments.length > 1 ? "column" : "row",
                                                buttonWidth: ((ref = building.tipology.apartments.length) === null || ref === void 0 ? void 0 : ref.length) > 2 ? 100 : 60,
                                                className: "h-full ".concat(building.tipology.apartments.length > 1 ? "" : " h-full", " ")
                                            }, tipology), index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "".concat(building.sharedSpaces.caption).concat(index),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                                        caption: building.sharedSpaces.caption,
                                        direction: "row",
                                        textAlign: "start",
                                        variant: textColor,
                                        title: building.sharedSpaces.title,
                                        desc: building.sharedSpaces.desc
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_custom["default"], {
                                        gap: 20,
                                        navigation: true,
                                        scrollbar: true,
                                        slidesPerView: 3,
                                        slidesPerViewMobile: 1.3,
                                        children: building.sharedSpaces.cards.map(function(param, index) {
                                            var caption = param.caption, desc = param.desc, image = param.image, title = param.title;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
                                                multimediaProps: {
                                                    image: image
                                                },
                                                className: "h-full ".concat(SectionText/* VARIANT_MAPS */.RQ[textColor], "  md:ml-0 ").concat(index === 0 ? "ml-5" : "", " ").concat(index === building.sharedSpaces.cards.length - 1 ? "mr-5" : ""),
                                                children: [
                                                    caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-caption text-caption--small mb-2",
                                                        children: caption
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: "text-heading text-heading--h4",
                                                        children: title
                                                    }),
                                                    desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-body text-body--primary mt-4",
                                                        children: desc
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "".concat(building.map.caption).concat(index),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                                        caption: building.map.caption,
                                        direction: "row",
                                        textAlign: "start",
                                        variant: textColor,
                                        title: building.map.title,
                                        desc: building.map.desc
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(map_card/* default */.Z, (0,_object_spread/* default */.Z)({
                                        orientation: "row"
                                    }, building.map.mapCard))
                                ]
                            })
                        ]
                    }, index);
                })
            })
        ]
    }));
};
BuildingCarrousel.displayName = "BuildingCarrousel";

;// CONCATENATED MODULE: ./components/templates/building-carrousel/index.ts

/* harmony default export */ var building_carrousel = (BuildingCarrousel);


/***/ })

}]);